import React from "react";
import { HELP_CAPACITIES } from "../../utils/menuPlusHelpAnimations.js";
import { createCompartmentTruck } from "./menuHelpTruck.js";
import "./TruckComparisonHelp.css";

// Bulle animée du menu Plus : deux camions, l'option désactivée en haut et activée en bas, sur le même minutage
// (scene.sceneAt). La vue s'approche d'un compartiment puis recule pour le bilan. L'animation repart à chaque
// ouverture de la bulle ; quand le mouvement est réduit, seule l'image du bilan est montrée.

const notePosition = (truck, place) => (place?.between ? `${(truck.percentOf(place.between[0]) + truck.percentOf(place.between[1])) / 2}%` : "50%");

export default function TruckComparisonHelp({ scene, colors, lead, rows, legend, rules, dataKey }) {
  const hosts = [React.useRef(null), React.useRef(null)];
  const marks = React.useRef(new Map());
  const mark = (key) => (node) => { if (node) marks.current.set(key, node); else marks.current.delete(key); };

  React.useEffect(() => {
    const trucks = hosts.map((ref) => createCompartmentTruck(ref.current, { capacities: HELP_CAPACITIES, colors }));
    rows.forEach((row, i) => row.notes?.forEach((note) => {
      const node = marks.current.get(note.key);
      if (node) node.style.left = notePosition(trucks[i], note.place);
    }));
    const still = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    const start = performance.now();
    let frame = 0;
    const render = (now) => {
      const state = scene.sceneAt(still ? scene.stillTime : (now - start) / 1000);
      trucks.forEach((truck, i) => {
        truck.setZoom(state.zoom, scene.focus);
        truck.draw(i === 0 ? state.off : state.on);
        truck.svg.style.opacity = state.opacity;
      });
      marks.current.forEach((node, key) => { node.style.opacity = state.show[key] ? "1" : "0"; });
      if (!still) frame = requestAnimationFrame(render);
    };
    frame = requestAnimationFrame(render);
    return () => { cancelAnimationFrame(frame); trucks.forEach((truck) => truck.destroy()); };
  }, []);

  return (
    <div className="tc-help" data-menu-help={dataKey}>
      <p className="m-0">{lead}</p>
      {rows.map((row, i) => (
        <div key={row.title} className="tc-row">
          <div className="tc-head"><b>{row.title}</b><span ref={mark(row.key)} className={`tc-chip tc-chip-${row.key}`}>{row.chip}</span></div>
          <div className="tc-truck">
            <div ref={hosts[i]} />
            {row.notes?.map((note) => <span key={note.key} ref={mark(note.key)} className="tc-note" style={{ top: note.top }}>{note.text}</span>)}
          </div>
        </div>
      ))}
      <div className="tc-legend">
        {legend.map((item) => (typeof item === "string"
          ? <span key={item}>{item}</span>
          : <span key={item.label} className="tc-swatch"><i style={{ background: item.color }} />{item.label}</span>))}
      </div>
      <ul className="tc-rules">{rules.map((rule, i) => <li key={i}>{rule}</li>)}</ul>
    </div>
  );
}
